import { TextareaField } from '@hypeit-gmbh/hypeit-ui';
import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type InternalNotePropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const InternalNote = <T extends FieldValues>({
  fieldName,
}: InternalNotePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <TextareaField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.INTERNAL_NOTE')}
      description={t('REPORTS.MAILING_FORM.INTERNAL_NOTE_DESCRIPTION')}
      placeholder={t('REPORTS.MAILING_FORM.INTERNAL_NOTE_PLACEHOLDER')}
      minRows={3}
      autosize
    />
  );
};
